import { useState } from "react";

export function money(value) {
  if (value == null || isNaN(value)) return "";
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(value);
}

/* Shopify's image CDN can serve center-cropped squares — far better for
   swatches/thumbnails than CSS-zooming a huge original. Non-Shopify URLs
   pass through untouched. */
export function thumb(url, size) {
  if (!url || !url.includes("cdn.shopify.com")) return url;
  const [base, query] = url.split("?");
  const params = new URLSearchParams(query || "");
  params.set("width", size);
  params.set("height", size);
  params.set("crop", "center");
  return `${base}?${params.toString()}`;
}

export function SaveChip({ percent, className = "" }) {
  if (!percent || percent <= 0) return null;
  return (
    <span className={`rounded-full bg-mint px-2.5 py-1 text-xs font-bold text-ink ${className}`}>
      Save {Math.round(percent)}%
    </span>
  );
}

export function TypeChip({ children, tone = "bg-sky-wash text-sky-deep" }) {
  return (
    <span className={`inline-block rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wider ${tone}`}>
      {children}
    </span>
  );
}

/* Overlapping image collage used as a bundle's "product photo" —
   pure CSS, no image processing. */
export function Collage({ urls, size = "h-64" }) {
  const images = (urls || []).filter(Boolean).slice(0, 4);
  if (images.length === 0) {
    return <div className={`mock-tile w-full ${size}`} />;
  }
  if (images.length === 1) {
    return (
      <div className={`w-full overflow-hidden rounded-xl bg-white ${size}`}>
        <img src={thumb(images[0], 800)} alt="" loading="lazy" className="h-full w-full object-cover" />
      </div>
    );
  }
  const grid = images.length === 2 ? "grid-cols-2" : "grid-cols-2 grid-rows-2";
  return (
    <div className={`grid w-full gap-1 overflow-hidden rounded-xl bg-white ${grid} ${size}`}>
      {images.map((src, index) => (
        <img
          key={index}
          src={thumb(src, 600)}
          alt=""
          loading="lazy"
          className={`h-full w-full object-cover ${images.length === 3 && index === 0 ? "row-span-2" : ""}`}
        />
      ))}
    </div>
  );
}

/* A demo add-to-cart button: satisfying press, honest tooltip. */
export function AddToCartButton({ label = "Add bundle to cart", disabled = false }) {
  const [state, setState] = useState("idle");

  const click = () => {
    if (disabled || state !== "idle") return;
    setState("added");
    setTimeout(() => setState("idle"), 2600);
  };

  return (
    <div>
      <button
        type="button"
        onClick={click}
        disabled={disabled}
        className={`btn-primary w-full text-base transition-colors ${state === "added" ? "!bg-sky-deep" : ""}`}
      >
        {state === "added" ? "Added to cart ✓" : label}
      </button>
      {state === "added" && (
        <p className="mt-2 text-center text-xs text-ink-soft animate-pop">
          This is a preview — on your store, this just worked for real.
        </p>
      )}
    </div>
  );
}
